import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface AmenitiesContainerProps {
  userId: string;
  propertyId: string;
}

export const AmenitiesContainer: React.FC<AmenitiesContainerProps> = ({
  userId,
  propertyId,
}) => {
  return (
    <Box sx={{ px: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Available Facilities"
        fieldKey="amenities.availableFacilities"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Parking and Storage"
        fieldKey="amenities.parkingAndStorage"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Bicycle Storage"
        fieldKey="amenities.bicycleStorage"
      />
    </Box>
  );
};